
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import { CountdownCourseButton, LabelCourseButton, WideCardType } from '@xt/client/types/home.d'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import CourseBtn from '@xt/www/components/courseBtn/index.vue'
import { Observer } from 'mobx-vue'
import { MixinsHomeClick } from '@xt/client/mixins/home'

@Observer
@Component({
  components: {
    CourseBtn,
    LazyImg
  }
})
export default class WideCard extends Mixins(MixinsHomeClick) {
  @Prop() dataSource: WideCardType

  btnConfig: LabelCourseButton | CountdownCourseButton | null = null

  handleClick() {
    if (this.dataSource.event) {
      this.onClickEvent(this.dataSource.event)
      return
    }
    this.formatterMoney
    window.open(`/commodity/${this.dataSource.productId}`)
  }

  created(): void {
    this.btnConfig = this.$store.$homeV2.mapCourseButton(this.dataSource)
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
